const JP_TRIAL_DISMISSED_STORAGE_KEY = 'podo:jp-trial-application:dismissed'

const getDismissedStorageKey = (userId: string | number) => `${JP_TRIAL_DISMISSED_STORAGE_KEY}:${userId}`

export const dismissJpTrialApplicationForSession = (userId: string | number) => {
  try {
    window.sessionStorage.setItem(getDismissedStorageKey(userId), 'true')
  } catch {
    // 저장소 접근이 제한된 환경에서도 닫기 동작 자체는 계속 진행한다.
  }
}

export const isJpTrialApplicationDismissedForSession = (userId: string | number) => {
  try {
    return window.sessionStorage.getItem(getDismissedStorageKey(userId)) === 'true'
  } catch {
    return false
  }
}
